
import { Options, Vue } from 'vue-class-component';
import NModalWindow, { NModalWindowSize } from '@/uikit/modal-window/NModalWindow.vue';
import NButton from '@/uikit/buttons/NButton.vue';
import NCheckbox from '@/uikit/checkbox/NCheckbox.vue';
import { dataModalController } from '@/store/application/data.modal.module';

@Options({
  components: {
    NCheckbox,
    NModalWindow,
    NButton
  }
})
export default class DataModal extends Vue {
  get dataModal() {
    return dataModalController;
  }

  get size() {
    return NModalWindowSize.Medium;
  }
}
